// src/app/services/coupon.service.ts
import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { BehaviorSubject, Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class CouponService {

  coupon: BehaviorSubject<any> = new BehaviorSubject({});

  constructor(private httpService: HttpService) { }
  /**
   * Obtiene los detalles de un cupón específico.
   * @param code CODE del cupón.
   * @returns Promesa con los detalles del cupón.
   */
  getCoupon(code: string): Promise<any> {
    // const body = stores && stores.length ? { store_ids: stores } : {};
    return this.httpService.post(`coupons/info`, {code});
  }


  setCoupon(coupon: any) {
    this.coupon.next(coupon);
  }

  getCouponObs$(): Observable<any> {
    return this.coupon;
  }
 
}